// "use client";

// import Link from "next/link";
// import {
//   Facebook,
//   Twitter,
//   Instagram,
//   Linkedin,
//   MapPin,
//   Phone,
//   Mail,
//   Clock,
//   Building2,
// } from "lucide-react";

// const quickLinks = [
//   { label: "About Us", href: "/about" },
//   { label: "Services", href: "/services" },
//   { label: "Pricing", href: "/pricing" },
//   { label: "Contact", href: "/contact" },
// ];

// const services = [
//   { label: "Bank Account Opening", href: "/essential-services/bank-account-opening-in-uae" },
//   { label: "Accounting Services", href: "/essential-services/accounting-services" },
//   { label: "Compliance Services", href: "/essential-services/corporate-tax" },
//   { label: "Health Insurance", href: "/essential-services/health-insurance" },
//   { label: "VAT & Tax Consultancy", href: "/essential-services/corporate-tax" },
//   { label: "IT Services", href: "/services" },
// ];

// const socials = [
//   { Icon: Facebook, href: "https://facebook.com", label: "Facebook" },
//   { Icon: Twitter, href: "https://twitter.com", label: "Twitter" },
//   { Icon: Instagram, href: "https://instagram.com", label: "Instagram" },
//   { Icon: Linkedin, href: "https://linkedin.com", label: "LinkedIn" },
// ];

// const contactItems = [
//   {
//     Icon: MapPin,
//     text: "Horizon Towers, Block D, Office 2009 Al Rashidiya 1, Ajman, UAE",
//     href: "https://maps.google.com/?q=Horizon+Towers+Block+D+Office+2009+Al+Rashidiya+1+Ajman+UAE",
//   },
//   { Icon: Phone, text: "+971 55 123 4567", href: "tel:+971551234567" },
//   { Icon: Mail, text: "info@awsbusinessmen.com", href: "mailto:info@awsbusinessmen.com" },
//   { Icon: Clock, text: "Sat – Thu: 9AM – 6PM", href: null },
// ];

// const GOLD = "#b8893b";
// const GOLD_LIGHT = "#d4a754";

// const Footer = () => {
//   const year = new Date().getFullYear();

//   return (
//     <footer
//       style={{
//         background: "#0a0a0a",
//         color: "#fff",
//         width: "100%",
//         minHeight: "78vh",
//         display: "flex",
//         flexDirection: "column",
//         fontFamily: "var(--font-raleway), sans-serif",
//       }}
//     >
//       {/* Top line */}
//       <div
//         style={{
//           height: "3px",
//           background: `linear-gradient(90deg, transparent, ${GOLD}, transparent)`,
//         }}
//       />

//       {/* Main Content */}
//       <div
//         style={{
//           maxWidth: "2200px",
//           margin: "0 auto",
//           padding:
//             "clamp(60px,10vh,120px) clamp(16px,5vw,100px) clamp(40px,6vh,60px)",
//           flex: 1,
//           display: "flex",
//           flexDirection: "column",
//         }}
//       >
//         {/* Grid */}
//         <div
//           className="footer-grid"
//           style={{
//             display: "grid",
//             gridTemplateColumns: "2fr 1fr 1fr 1.4fr",
//             gap: "clamp(24px,3vw,60px)",
//             borderBottom: "1px solid rgba(255,255,255,0.08)",
//             paddingBottom: "40px",
//             marginTop: "auto",
//             marginBottom: "auto",
//           }}
//         >
//           {/* Brand */}
//           <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
//             <Link href="/" className="footer-brand" style={{ display: "flex", alignItems: "center", gap: "14px", textDecoration: "none", color: "inherit" }}>
//               <div
//                 style={{
//                   width: "50px",
//                   height: "50px",
//                   borderRadius: "12px",
//                   background: `linear-gradient(135deg, ${GOLD}, #8a6428)`,
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                 }}
//               >
//                 <Building2 size={24} color="#fff" />
//               </div>
//               <div style={{ fontFamily: "var(--font-montserrat)" }}>
//                 <div style={{ fontSize: "24px", fontWeight: 800 }}>AWS</div>
//                 <div style={{ fontSize: "12px", color: GOLD_LIGHT }}>
//                   Businessmen Services
//                 </div>
//               </div>
//             </Link>

//             <p 
//               style={{ 
//                 color: "rgba(255,255,255,0.6)", 
//                 fontSize: "clamp(14px, 1.2vw, 16px)",
//                 lineHeight: "1.6" 
//               }}
//             >
//               AWS Businessmen simplifies your journey to success in the UAE and beyond. From company formation and worldwide visa services to immigration, accounting, and tax compliance, we provide complete, reliable support.
//             </p>

//             <div style={{ display: "flex", gap: "10px" }}>
//               {socials.map(({ Icon, label, href }) => (
//                 <a
//                   key={label}
//                   href={href}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="social-link"
//                   aria-label={label}
//                   style={{
//                     width: "38px",
//                     height: "38px",
//                     borderRadius: "50%",
//                     border: "1px solid rgba(255,255,255,0.2)",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     cursor: "pointer",
//                     color: "inherit",
//                     transition: "all 0.3s ease",
//                   }}
//                 >
//                   <Icon size={16} />
//                 </a>
//               ))}
//             </div>
//           </div>

//           {/* Quick Links */}
//           <div>
//             <h4 
//               style={{ 
//                 marginBottom: "16px", 
//                 fontFamily: "var(--font-montserrat)",
//                 fontSize: "clamp(18px, 2vw, 20px)",
//                 fontWeight: "600"
//               }}
//             >
//               Quick Links
//             </h4>
//             <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
//               {quickLinks.map((l) => (
//                 <Link
//                   key={l.label}
//                   href={l.href}
//                   className="footer-link"
//                 >
//                   {l.label}
//                 </Link>
//               ))}
//             </div>
//           </div>

//           {/* Services */}
//           <div>
//             <h4 
//               style={{ 
//                 marginBottom: "16px", 
//                 fontFamily: "var(--font-montserrat)",
//                 fontSize: "clamp(18px, 2vw, 20px)",
//                 fontWeight: "600"
//               }}
//             >
//               Services
//             </h4>
//             <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
//               {services.map((s) => (
//                 <Link
//                   key={s.label}
//                   href={s.href}
//                   className="footer-link"
//                 >
//                   {s.label}
//                 </Link>
//               ))}
//             </div>
//           </div>

//           {/* Contact */}
//           <div>
//             <h4 
//               style={{ 
//                 marginBottom: "16px", 
//                 fontFamily: "var(--font-montserrat)",
//                 fontSize: "clamp(18px, 2vw, 20px)",
//                 fontWeight: "600"
//               }}
//             >
//               Contact
//             </h4>
//             {contactItems.map(({ Icon, text, href }, i) => (
//               <div key={i} style={{ marginBottom: "12px" }}>
//                 {href ? (
//                   <a
//                     href={href}
//                     className="contact-link"
//                     target={href.startsWith("http") ? "_blank" : undefined}
//                     rel={href.startsWith("http") ? "noopener noreferrer" : undefined}
//                     style={{
//                       display: "flex",
//                       gap: "10px",
//                       alignItems: "center",
//                       textDecoration: "none",
//                       color: "inherit",
//                       transition: "all 0.3s ease",
//                     }}
//                   >
//                     <Icon size={16} color={GOLD} />
//                     <span>{text}</span>
//                   </a>
//                 ) : (
//                   <div
//                     style={{
//                       display: "flex",
//                       gap: "10px",
//                       alignItems: "center",
//                       opacity: 0.7,
//                     }}
//                   >
//                     <Icon size={16} color={GOLD} />
//                     <span>{text}</span>
//                   </div>
//                 )}
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Bottom */}
//         <div
//           style={{
//             marginTop: "auto",
//             paddingTop: "20px",
//             display: "flex",
//             justifyContent: "space-between",
//             flexWrap: "wrap",
//             opacity: 0.6,
//             fontSize: "14px",
//           }}
//         >
//           <p>© {year} AWS Businessmen Services. All rights reserved.</p>
//           <div style={{ display: "flex", gap: "20px" }}>
//             <Link href="/privacy" className="bottom-link">Privacy Policy</Link>
//             <Link href="/terms-of-service" className="bottom-link">Terms</Link>
//             <Link href="/cookies" className="bottom-link">Cookies</Link>
//           </div>
//         </div>
//       </div>

//       <style jsx>{`
//         .footer-link {
//           color: rgba(255, 255, 255, 0.7);
//           text-decoration: none;
//           transition: all 0.3s ease;
//           width: fit-content;
//           cursor: pointer;
//           font-size: clamp(14px, 1.2vw, 16px);
//         }
//         .footer-link:hover {
//           color: ${GOLD};
//           transform: translateX(5px);
//         }
//         .social-link:hover {
//           background: ${GOLD};
//           border-color: ${GOLD};
//           color: #fff;
//           transform: translateY(-3px);
//         }
//         .contact-link {
//           opacity: 0.7;
//         }
//         .contact-link:hover {
//           opacity: 1;
//           color: ${GOLD_LIGHT};
//         }
//         .bottom-link {
//           color: inherit;
//           text-decoration: none;
//           transition: color 0.3s ease;
//           cursor: pointer;
//         }
//         .bottom-link:hover {
//           color: ${GOLD};
//         }
//         .footer-brand:hover div:last-child div:first-child {
//           color: ${GOLD};
//           transition: color 0.3s ease;
//         }

//         @media (max-width: 1024px) {
//           .footer-grid {
//             grid-template-columns: 1fr 1fr !important;
//           }
//         }
//         @media (max-width: 600px) {
//           .footer-grid {
//             grid-template-columns: 1fr !important;
//           }
//         }
//       `}</style>
//     </footer>
//   );
// };

// export default Footer;





"use client";

import Link from "next/link";
import {
  Facebook,
  Twitter,
  Instagram,
  Linkedin,
  MapPin,
  Phone,
  Mail,
  Clock,
  Building2,
} from "lucide-react";

const quickLinks = [
  { label: "About Us", href: "/about" },
  { label: "Global Visa services", href: "/services" },
  { label: "Pricing", href: "/pricing" },
  { label: "Contact", href: "/contact" },
];

const services = [
  { label: "Bank Account Opening", href: "/essential-services/bank-account-opening-in-uae" },
  { label: "Accounting Services", href: "/essential-services/accounting-services" },
  { label: "Compliance Services", href: "/essential-services/compliance-services" },
  { label: "Health Insurance", href: "/essential-services/health-insurance" },
  { label: "VAT & Tax Consultancy", href: "/essential-services/corporate-tax" },
  { label: "IT Services", href: "/essential-services/it-services" },
];

const socials = [
  { Icon: Facebook, href: "https://facebook.com", label: "Facebook" },
  { Icon: Twitter, href: "https://twitter.com", label: "Twitter" },
  { Icon: Instagram, href: "https://instagram.com", label: "Instagram" },
  { Icon: Linkedin, href: "https://linkedin.com", label: "LinkedIn" },
];

const contactItems = [
  {
    Icon: MapPin,
    text: "Horizon Towers, Block D, Office 2009 Al Rashidiya 1, Ajman, UAE",
    href: "https://maps.google.com/?q=Horizon+Towers+Block+D+Office+2009+Al+Rashidiya+1+Ajman+UAE",
  },
  { Icon: Phone, text: "+971 50 798 7470", href: "tel:+971507987470" },
  { Icon: Mail, text: "info@awsbusinessmen.com", href: "mailto:info@awsbusinessmen.com" },
  { Icon: Clock, text: "Mon – Sat: 9AM – 9PM", href: null },
];

const GOLD = "#b8893b";
const GOLD_LIGHT = "#d4a754";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="cf-footer">
      {/* Gold top line */}
      <div className="cf-top-line" />

      {/* ===== MAIN WRAPPER ===== */}
      <div className="cf-wrapper">
        {/* ========== LEFT COLUMN ========== */}
        <div className="cf-left">
          {/* Description at Top */}
          <div className="cf-left-content">
            <p className="cf-description">
              AWS Businessmen simplifies your journey to success in the UAE and beyond. From company formation and worldwide visa services to immigration, accounting, and tax compliance, we provide complete, reliable support.
            </p>
          </div>

          {/* Logo at Bottom */}
          <Link href="/" className="cf-logo-link">
            <div className="cf-logo-icon mt-8 md:mt-0">
              <Building2 size={24} color="#fff" />
            </div>
            <div>
              <div className="cf-logo-text mt-2 md:mt-4">AWS</div>
              <div className="cf-logo-sub">Businessmen Services</div>
            </div>
          </Link>
        </div>

        {/* ========== RIGHT COLUMN ========== */}
        <div className="cf-right">
          {/* Nav Row - Quick Links, Services, Contact Info */}
          <div className="cf-nav-row">
            {/* Quick Links */}
            <div className="cf-nav-col">
              <h4 className="cf-section-label">Quick Links</h4>
              <ul className="cf-nav-list">
                {quickLinks.map((l) => (
                  <li key={l.label}>
                    <Link href={l.href} className="cf-nav-link">
                      <span className="cf-dot" />
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Services */}
            <div className="cf-nav-col">
              <h4 className="cf-section-label">Services</h4>
              <ul className="cf-nav-list">
                {services.map((s) => (
                  <li key={s.label}>
                    <Link href={s.href} className="cf-nav-link">
                      <span className="cf-dot" />
                      {s.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div className="cf-nav-col">
              <h4 className="cf-section-label">Contact</h4>
              <ul className="cf-contact-list">
                {contactItems.map(({ Icon, text, href }, i) => (
                  <li key={i}>
                    {href ? (
                      <a
                        href={href}
                        className="cf-contact-link"
                        target={href.startsWith("http") ? "_blank" : undefined}
                        rel={href.startsWith("http") ? "noopener noreferrer" : undefined}
                      >
                        <Icon size={16} color={GOLD} className="cf-contact-icon" />
                        <span>{text}</span>
                      </a>
                    ) : (
                      <div className="cf-contact-static">
                        <Icon size={16} color={GOLD} className="cf-contact-icon" />
                        <span>{text}</span>
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="cf-bottom-bar">
            <div className="cf-divider cf-divider-gray" />
            <div className="cf-bottom-content">
              {/* Copyright */}
              {/* <div className="cf-bottom-block"> */}
                {/* <div className="cf-bottom-label">COPYRIGHT BY</div> */}
                {/* <div className="cf-bottom-value"> {year}</div> */}
              {/* </div> */}

              {/* Hours */}
              <div className="cf-bottom-block">
                <div className="cf-bottom-label">MONDAY - SATURDAY</div>
                <div className="cf-bottom-value">09 : 00 AM - 09 : 00 PM</div>
              </div>

              {/* Social */}
              <div className="cf-bottom-block">
                <div className="cf-bottom-label">FOLLOW</div>
                <div className="cf-social-icons">
                  {socials.map(({ Icon, label, href }) => (
                    <a
                      key={label}
                      href={href}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={label}
                      className="cf-social-link"
                    >
                      <Icon size={18} />
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Legal Links */}
         <div className="cf-legal-row">
  <div className="cf-legal-links">
    <Link href="/privacy" className="cf-legal-link">
      Privacy Policy
    </Link>
    <Link href="/terms-of-service" className="cf-legal-link">
      Terms
    </Link>
    <Link href="/cookies" className="cf-legal-link">
      Cookies
    </Link>
  </div>

  <div className="cf-dev-text ">
    Designed || Developed by{" "}
    <a
      href="https://broshtech.com"
      target="_blank"
      rel="noopener noreferrer"
      className="cf-broshtech underline"
    >
      Broshtech
    </a>
  </div>
</div> 
        </div>
      </div>

      <style jsx>{`
        /* ===== BASE ===== */
        .cf-footer {
          background: #0a0a0a;
          color: #fff;
          width: 100%;
          font-family: var(--font-raleway), sans-serif;
          max-height: 100vh;
          overflow: hidden;
        }

        .cf-top-line {
          height: 3px;
          background: linear-gradient(90deg, transparent, ${GOLD}, transparent);
        }

        /* ===== WRAPPER ===== */
        .cf-wrapper {
          max-width: 1800px;
          margin: 0 auto;
          display: flex;
          flex-direction: row;
          height: auto;
        }

        /* ===== LEFT COLUMN ===== */
        .cf-left {
          width: 30%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: clamp(50px, 7vh, 75px) clamp(30px, 5vw, 60px);
          border-right: 1px solid rgba(255, 255, 255, 0.06);
          overflow-y: auto;
        }


        .cf-legal-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 20px;

  padding-left: clamp(30px, 3vw, 45px);
  margin-top: clamp(28px, 3.5vh, 38px);
  padding-top: clamp(16px, 2.2vh, 24px);

  border-top: 1px solid rgba(255, 255, 255, 255);
}

.cf-legal-links {
  display: flex;
  gap: clamp(25px, 3.2vw, 36px);
  flex-wrap: wrap;
}

.cf-dev-text {
  margin-left: auto;
  color: #ffffff;
  font-size: clamp(15px, 2vw, 13px);
}
        /* Left Content - Description at top */
        .cf-left-content {
          display: flex;
          flex-direction: column;
        }

        .cf-description {
          color: rgba(255, 255, 255, 0.6);
          font-size: clamp(13px, 1.1vw, 15px);
          line-height: 1.6;
          margin: 0;
        }

        /* Logo - at bottom */
        .cf-logo-link {
          display: flex;
          align-items: center;
          gap: 12px;
          text-decoration: none;
          color: inherit;
          transition: opacity 0.3s ease;
          margin-top: auto;
        }
        .cf-logo-link:hover {
          opacity: 0.85;
        }

        .cf-logo-icon {
          width: clamp(40px, 4vw, 48px);
          height: clamp(40px, 4vw, 48px);
          border-radius: 10px;
          background: linear-gradient(135deg, ${GOLD}, #8a6428);
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .cf-logo-text {
          font-family: var(--font-montserrat), sans-serif;
          font-size: clamp(18px, 2vw, 22px);
          font-weight: 800;
          line-height: 1;
        }

        .cf-logo-sub {
          font-size: clamp(10px, 0.9vw, 11px);
          color: ${GOLD_LIGHT};
          margin-top: 2px;
        }

        /* ===== RIGHT COLUMN ===== */
        .cf-right {
          width: 70%;
          background: #141416;
          padding: clamp(45px, 7vh, 75px) clamp(30px, 5vw, 60px);
          display: flex;
          flex-direction: column;
          overflow-y: auto;
        }

        /* Section Label */
        .cf-section-label {
          color: #8a6428;
          font-family: var(--font-montserrat), Helvetica, sans-serif;
          font-size: clamp(14px, 1.2vw, 16px);
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 1px;
          margin: 0 0 clamp(12px, 2vh, 18px) 0;
        }

        /* ===== NAV ROW ===== */
        .cf-nav-row {
          display: flex;
          gap: clamp(44px, 5.5vw, 80px);
          margin-bottom: clamp(50px, 7vh, 60px);
          padding-left: clamp(25px, 3vw, 40px);
        }

        .cf-nav-col {
          display: flex;
          flex-direction: column;
          flex: 1;
        }

        .cf-nav-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          flex-direction: column;
          gap: clamp(8px, 1.2vh, 12px);
        }

        .cf-nav-link {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: clamp(13px, 1.1vw, 15px);
          font-weight: 400;
          line-height: 1.6;
          color: rgba(255, 255, 255, 0.7);
          text-decoration: none;
          transition: all 0.3s ease;
        }
        .cf-nav-link:hover {
          color: ${GOLD_LIGHT};
        }

        .cf-dot {
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background: ${GOLD};
          flex-shrink: 0;
        }

        /* Contact List in Right Column */
        .cf-contact-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          flex-direction: column;
          gap: clamp(10px, 1.5vh, 14px);
        }

        .cf-contact-link {
          display: flex;
          gap: 10px;
          align-items: flex-start;
          text-decoration: none;
          color: rgba(255, 255, 255, 0.7);
          font-size: clamp(13px, 1.1vw, 15px);
          line-height: 1.4;
          transition: color 0.3s ease;
        }
        .cf-contact-link:hover {
          color: ${GOLD_LIGHT};
        }

        .cf-contact-static {
          display: flex;
          gap: 10px;
          align-items: flex-start;
          color: rgba(255, 255, 255, 0.5);
          font-size: clamp(13px, 1.1vw, 15px);
          line-height: 1.4;
        }

        .cf-contact-icon {
          flex-shrink: 0;
          margin-top: 2px;
        }

        /* Dividers */
        .cf-divider {
          width: 100%;
          height: 1px;
        }
        .cf-divider-gray {
          background: rgba(255, 255, 255, 0.15);
          margin-bottom: clamp(22px, 3.5vh, 30px);
        }

        /* ===== BOTTOM BAR ===== */
        .cf-bottom-bar {
          padding-left: clamp(30px, 3vw, 45px);
          margin-top: auto;
        }

        .cf-bottom-content {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: clamp(28px, 3.5vh, 34px);
        }

        .cf-bottom-block {
          display: flex;
          flex-direction: column;
          gap: clamp(14px, 1.4vh, 18px);
        }

        .cf-bottom-label {
          color: #7D7D80;
          font-family: var(--font-montserrat), Helvetica, sans-serif;
          font-size: clamp(11px, 1vw, 13px);
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .cf-bottom-value {
          color: #E5E5E6;
          font-size: clamp(14px, 1.3vw, 17px);
          font-weight: 500;
        }

        /* Socials */
        .cf-social-icons {
          display: flex;
          gap: clamp(16px, 2vw, 22px);
          align-items: center;
        }

        .cf-social-link {
          color: rgba(255, 255, 255, 0.7);
          display: flex;
          align-items: center;
          text-decoration: none;
          transition: all 0.3s ease;
        }
        .cf-social-link:hover {
          color: ${GOLD_LIGHT};
          transform: translateY(-2px);
        }

        /* Legal */
        .cf-legal-row {
          display: flex;
          gap: clamp(28px, 3.2vw, 36px);
          padding-left: clamp(30px, 3vw, 45px);
          margin-top: clamp(28px, 3.5vh, 38px);
          padding-top: clamp(16px, 2.2vh, 24px);
          border-top: 1px solid rgba(255, 255, 255, 0.04);
        }

        .cf-legal-link {
          color: rgba(255, 255, 255, 0.4);
          text-decoration: none;
          font-size: clamp(12px, 1vw, 13px);
          transition: color 0.3s ease;
        }
        .cf-legal-link:hover {
          color: ${GOLD};
        }

        /* ===== RESPONSIVE ===== */

        /* Tablet */
        @media (max-width: 1024px) {
          .cf-wrapper {
            flex-direction: column;
            height: auto;
            max-height: none;
          }
          .cf-footer {
            max-height: none;
          }
          .cf-left {
            width: 100%;
            padding: 40px 25px;
            border-right: none;
            border-bottom: 1px solid rgba(255, 255, 255, 0.06);
            overflow-y: visible;
          }
          .cf-right {
            width: 100%;
            padding: 35px 25px;
            overflow-y: visible;
          }
          .cf-nav-row {
            padding-left: 0;
            flex-wrap: wrap;
          }
          .cf-nav-col {
            min-width: 200px;
          }
          .cf-bottom-bar {
            padding-left: 0;
          }
          .cf-legal-row {
            padding-left: 0;
          }
        }

        /* Mobile */
        @media (max-width: 767px) {
          .cf-left {
            padding: 30px 18px;
          }
          .cf-right {
            padding: 25px 18px;
          }
          .cf-nav-row {
            flex-direction: column;
            gap: 25px;
          }
          .cf-bottom-content {
            flex-direction: column;
            gap: 18px;
          }
          .cf-legal-row {
            flex-wrap: wrap;
            gap: 10px;
          }
        }

        /* Small Mobile */
        @media (max-width: 480px) {
          .cf-left {
            padding: 25px 15px;
          }
          .cf-right {
            padding: 20px 15px;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;